import React, { Component } from 'react'
import './index.scss'

import i18n from '@/i18n'

class PremiumSection extends Component {

    handleClickPayment = () => {
        this.props.history.push('/payment')
    }

    renderItems = () => {
        const items = [
            {
                img: 'https://front.videomonster.com/images-7cuytg20/web/home/premium/watermark-remove.svg',
                title: i18n.t("web.newhome.premium.section.removewatermark"),
				des: i18n.t("web.newhome.premium.section.removewatermark.des")
            },
            {
                img: 'https://front.videomonster.com/images-7cuytg20/web/home/premium/other-ratio.svg',
                title: i18n.t("web.newhome.premium.section.other.ratio"),
                des: i18n.t("web.newhome.premium.section.other.ratio.des"),
            },
            {
                img: 'https://front.videomonster.com/images-7cuytg20/web/home/premium/getty-images.svg',
                title: i18n.t("web.newhome.premium.section.gettyimages"),
                des: i18n.t("web.newhome.premium.section.gettyimages.des"),
            },
            {
                img: 'https://front.videomonster.com/images-7cuytg20/web/home/premium/gif.svg',
                title: i18n.t("web.newhome.premium.section.gif"),
                des: i18n.t("web.newhome.premium.section.gif.des"),
            },
            {
                img: 'https://front.videomonster.com/images-7cuytg20/web/home/premium/quick-server.svg',
                title: i18n.t("web.newhome.premium.section.fastserver"),
                des: i18n.t("web.newhome.premium.section.fastserver.des"),
            },
            {
                img: 'https://front.videomonster.com/images-7cuytg20/web/home/premium/thumb-download.svg',
                title: i18n.t("web.newhome.premium.section.thumb.download"),
                des: i18n.t("web.newhome.premium.section.thumb.download.des"),
            }
        ]

        return (
            <div className="item-container">
                {items.map(({ img, title, des }) => (
                    <div className="item-wrapper">
                        <img src={img} alt="" />
                        <div className={`title`}>{title}</div>
                        <div className='des'><div>{des}</div></div>
                    </div>
                ))}
            </div>
        );
    }

    render() {
        return (
            <div className='premium-section-root-container'>
                <div className='subtitle'>Premium</div>
                <div className='heading'>{i18n.t("web.newhome.premium.section.title")}</div>
                {this.renderItems()}
                <div className='setting-btn' onClick={this.handleClickPayment}>{i18n.t("web.newhome.premium.section.paymentbtn")}</div>
            </div>
        )
    }
}

export default PremiumSection